import React, { Component } from 'react';
import Base from '../../../rebase';
import Firebase from 'firebase';
import PropTypes from 'prop-types';
import RSVPPerson from './RSVPPerson';
import RSVPPersonSummary from './RSVPPersonSummary';
import {
  PageHeader,
  Well
} from 'react-bootstrap';

class RSVPSection extends Component {

  constructor(props) {
    super(props);
    this.state = {
      guests: []
    };
  }


  componentWillMount() {
    Firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.ref = Base.fetch('users/' + user.uid + '/guests', {
          context: this,
          asArray: true
        })
        .then(data => {
          this.setState({guests: data});
        });
      } else {
        // No user is signed in.
        console.log("RSVPSection.jsx: not logged in");
      }
    });
  }

  render() {
    return (
      <div>
          <PageHeader>{this.props.title}</PageHeader>
          {
            this.state.guests.map((item, index) => (
            <RSVPPerson guestID={item} />
            ))
          }
      </div>
      )
  }
}

export default RSVPSection;



// WEBPACK FOOTER //
// ./src/reusable_components/page_components/RSVP/RSVPSection.jsx